export const buildAccountLanguages = ({ primaryLangId, supportedLangs = [] }) => {
    const primary = {
        IsPrimary: true,
        LanguageID: primaryLangId,
    };

    const supportive = supportedLangs.map((item) => ({
        IsPrimary: false,
        LanguageID: item?.id,
    }));

    return [...supportive, primary];
};

export const mapClientCodes = ({
    finalCodeList = [],
    codeKey = "ClientCode",
    codeNameKey = "ClientCodeName",
}) => {
    return finalCodeList.map((item) => ({
        [codeKey]: item.clientCode,
        [codeNameKey]: item.clientCodeName,
    }));
};

export const mapClientUsersWithOrder = (clientUsers = []) => {
    return clientUsers.map((item, index) => ({
        Id: item.Id,
        Orders: index + 1,
    }));
};

export const mapAccountTeamMembersWithOrder = (accountTeamMembers = []) => {
    return accountTeamMembers.map((item, index) => ({
        StaffId: item.teamMemberId,
        BioId: item.bioId,
        Orders: index + 1,
    }));
};

export const mapClientAccountAdmins = (accountAdmins = []) => {
    return accountAdmins.map((item) => ({
        adminId: item.adminId,
    }));
};

export const buildEditSubmitTransformData = ({
    data,
    finalCodeList = [],
    clientTeamTableData = [],
    accountTeamMemberTableData = [],
    accountAdminTableData = [],
    codeKey = "ClientCode",
    codeNameKey = "ClientCodeName",
}) => {
    const langList = buildAccountLanguages({
        primaryLangId: data.primary_lang?.id,
        supportedLangs: data.supported_lang || [],
    });

    const codeList = mapClientCodes({
        finalCodeList,
        codeKey,
        codeNameKey,
    });

    const clientUserList = mapClientUsersWithOrder(clientTeamTableData || []);

    const accountTeamMembList = mapAccountTeamMembersWithOrder(
        accountTeamMemberTableData || []
    );

    const clientAccAdminList = mapClientAccountAdmins(accountAdminTableData || []);

    return {
        langList,
        codeList,
        clientUserList,
        accountTeamMembList,
        clientAccAdminList,
    };
};

export const buildEditClientAccountBody = ({
    data,
    clientAccountId,
    updatedBy,
    langList,
    clientUserList,
    accountTeamMembList,
    clientAccAdminList,
    codeList,
    removeLogo,
    currentLogo,
}) => {
    return {
        Id: clientAccountId,
        ClientAccountName: data.client_acc_name || "",
        IsActive: true,
        UpdatedBy: updatedBy || "",
        CurrencyId: data?.CurrencyId?.id,
        DataClassificationKey: data.ClientType?.id,
        AccountLanguages: langList || [],
        ClientUserTeams: clientUserList || [],
        AccountUserTeams: accountTeamMembList || [],
        ClientAccountAdmins: clientAccAdminList || [],
        ClientAccountCodes: codeList || [],
        Logo: !!removeLogo ? "" : currentLogo,
    };
};

export const buildEditClientSubAccountBody = ({
    data,
    userId,
    clientSubAccountId,
    updatedBy,
    langList,
    clientUserList,
    accountTeamMembList,
    clientAccAdminList,
    codeList,
    removeLogo,
    currentLogo,
}) => {
    return {
        UserId: userId,
        ParentID: data?.client_acc_name?.id,
        Id: clientSubAccountId,
        ClientAccountName: data?.client_sub_acc_name || "",
        IsActive: true,
        UpdatedBy: updatedBy || "",
        CurrencyId: data?.CurrencyId?.id,
        DataClassificationKey: data?.ClientType?.id,
        AccountLanguages: langList || [],
        ClientUserTeams: clientUserList || [],
        AccountUserTeams: accountTeamMembList || [],
        ClientAccountAdmins: clientAccAdminList || [],
        ClientAccountCodes: codeList || [],
        Logo: !!removeLogo ? "" : currentLogo,
    };
};
